module.exports = __webpack_public_path__ + "static/img/DeluxeFamilyRoom1.e0b362a5.jpg";